import { useState } from 'react';
import { computePrebid, MIN_MARGIN, DEFAULT_RATE, tradeInfo } from '../utils/prebid';
import PrebidResult, { PREBID_CSS, TradeSelect } from '../components/PrebidResult';

/* Pre-Bid Calculator — admins only.
   Before a bid goes out: does this sale price leave the minimum margin (MIN_MARGIN in utils/prebid.js)?
   The formula lives in utils/prebid.js and is shared with the Pre-Bid tab on
   Add / Update Record, the Job Tracker and the Cashflow report.            */

export default function PreBidCalculator() {
  const [trade, setTrade] = useState('coating');
  const [squares, setSquares] = useState('');
  const [sale, setSale] = useState('');
  const [rate, setRate] = useState(DEFAULT_RATE);

  const p = computePrebid({ trade, squares, sale, rate });
  const t = tradeInfo(trade);
  const unitsLabel = 'Number of ' + (t ? t.units : 'squares');

  return (
    <>
      <style>{PREBID_CSS}</style>
      <div className="page-header">
        <h2>Pre-Bid Calculator</h2>
        <div style={{ fontSize: 13, color: '#888' }}>
          Check a bid before it goes out. Every job needs at least a {Math.round(MIN_MARGIN * 100)}% margin after labor, material, marketing and commission. Admins and approved staff only.
        </div>
      </div>
      <div className="page-body">
        <div className="pb-grid">
          <div className="pb-field">
            <label>Trade</label>
            <TradeSelect value={trade} onChange={setTrade} />
          </div>
          <div className="pb-field">
            <label>{unitsLabel}</label>
            <input className="form-input" inputMode="decimal" placeholder="e.g. 20" value={squares} onChange={e => setSquares(e.target.value)} />
          </div>
          <div className="pb-field">
            <label>Sale price (total job)</label>
            <input className="form-input" inputMode="decimal" placeholder="e.g. 12,000" value={sale} onChange={e => setSale(e.target.value)} />
          </div>
          <div className="pb-field">
            <label>Rep's commission rate</label>
            <div className="pb-seg">
              {[0.30, 0.40].map(r => (
                <button key={r} type="button" className={rate === r ? 'on' : ''} onClick={() => setRate(r)}>{Math.round(r * 100)}%</button>
              ))}
            </div>
          </div>
        </div>
        <PrebidResult p={p} emptyText={`Enter the number of ${t ? t.units : 'squares'} and the sale price to check the margin.`} />
      </div>
    </>
  );
}
